import { ComponentProps } from 'react';
import { SelectField } from '@hypeit-gmbh/hypeit-ui';
import { Grid } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { DEFAULT_SPAN, TRANS_KEY, useAddressPrefix } from '../Root';
import { states } from './data';

type StateProps = {
  span?: number;
} & Omit<ComponentProps<typeof SelectField>, 'fieldName' | 'data'>;

export const State: React.FC<StateProps> = ({ span, ...props }) => {
  const { t } = useTranslation();
  const prefix = useAddressPrefix();

  return (
    <Grid.Col span={span ?? DEFAULT_SPAN}>
      <SelectField
        fieldName={`${prefix}.state`}
        label={t(`${TRANS_KEY}.STATE_LABEL`)}
        data={states}
        required
        searchable
        {...props}
      />
    </Grid.Col>
  );
};
